export default __webpack_public_path__ + "static/media/photo--sm--113.922b3716.jpg";